import { configureStore } from "@reduxjs/toolkit";
import filterSlice from "./filter-slice";
import stepsSlice from "./steps-slice";
import sidebarSlice from "./sidebar-slice";
import fbSlice from "./fb-slice";
import loginSlice from "./login-slice";
import homePageProfile from "./homepage-profile-slice";
import campaignSlice from "./campaigns-slice";
import userSlice from "./user-slice";
import productsSlice from "./products-slice";
import businessSlice from "./business-slice";

const store = configureStore({
  reducer: {
    filter: filterSlice.reducer,
    steps: stepsSlice.reducer,
    sidebar: sidebarSlice.reducer,
    fb: fbSlice.reducer,
    login: loginSlice.reducer,
    homePageProfile: homePageProfile.reducer,
    campaigns: campaignSlice.reducer,
    user: userSlice.reducer,
    products: productsSlice.reducer,
    business: businessSlice.reducer,
  },
});

export default store;
